import { GetServerSideProps } from 'next'
import { SEOHead } from '~/components/business/SEOHead'
import { GlobalRequest } from '~/components/global-request'
import {
  GET_AI_MENU,
  GET_AI_TOTAL_INFO,
  GET_AI_MEMBER_LIST,
  GET_COLLECTED_STYLE_MODEL_LIST,
} from '~/graphqls/gqls'
import {
  getAIMenu,
  getAITotalInfo_pictureGraph_aiArtworkTotalInfo,
  getAITotalInfo,
  getAIMemberListVariables,
  getAIMemberList_accountModule_userMemberCardList,
  getAIMemberList,
  AccountGroupTypeEnum,
  getCollectedStyleModelList,
  AIOptions,
  AiCreateArtworkPattern,
  AiCreateArtworkModel,
} from '~/graphqls/types'
import { Layout } from '~/layouts/default'
import styles from './index.module.css'
import { sortBy } from '~/utils'
import { observer } from 'mobx-react-lite'
import Framework from '~/components/pages/ai/Framework'
import { DEFAULT_OPTIONS } from '~/components/pages/ai/ai-form/atom'

const AICreator = (props: {
  options: AIOptions
  totalInfo: getAITotalInfo_pictureGraph_aiArtworkTotalInfo
  memberList: getAIMemberList_accountModule_userMemberCardList[]
}) => {
  return (
    <Layout className={styles.layout}>
      <SEOHead title="AI 创作" />
      <Framework
        pageProps={{
          ...props,
          lockModel: AiCreateArtworkModel.STABLE_DIFFUSION,
          lockModelCode: DEFAULT_OPTIONS.MODEL_CODE,
          lockPattern: AiCreateArtworkPattern.GENERAL,
        }}
      />
    </Layout>
  )
}

export default observer(AICreator)

export const getServerSideProps: GetServerSideProps = async context => {
  const { client, initialState } = await GlobalRequest(context)

  const [menuRes, collectedStyleModelListRes, totalInfoRes, memberListRes] =
    await Promise.all([
      client.query<getAIMenu>({
        query: GET_AI_MENU,
        fetchPolicy: 'no-cache',
      }),
      client.query<getCollectedStyleModelList>({
        query: GET_COLLECTED_STYLE_MODEL_LIST,
        fetchPolicy: 'no-cache',
      }),
      client.query<getAITotalInfo>({
        query: GET_AI_TOTAL_INFO,
        fetchPolicy: 'no-cache',
      }),
      client.query<getAIMemberList, getAIMemberListVariables>({
        query: GET_AI_MEMBER_LIST,
        fetchPolicy: 'no-cache',
      }),
    ])

  return {
    props: {
      initialState,
      options:
        {
          ...menuRes.data.pictureGraph?.aiCreateArtworkOptionMenu,
          collectedStyleModelList:
            collectedStyleModelListRes.data.pictureSocialQuery
              ?.collectedStyleModelList || [],
        } || {},
      totalInfo: totalInfoRes.data.pictureGraph?.aiArtworkTotalInfo || {},
      memberList: sortBy(
        memberListRes.data.accountModule?.userMemberCardList || [],
        [
          AccountGroupTypeEnum.ORIGIN_CARD,
          AccountGroupTypeEnum.BRONZE_CARD,
          AccountGroupTypeEnum.SILVER_CARD,
          AccountGroupTypeEnum.GOLD_CARD,
          AccountGroupTypeEnum.PLATINUM_CARD,
        ],
        (it: getAIMemberList_accountModule_userMemberCardList) => it?.cardType
      ),
    },
  }
}
